// extracted by mini-css-extract-plugin
export default {"goalContainer":"setGoal_goalContainer__iKHpA","label":"setGoal_label__8z+3Z","labelWithSub":"setGoal_labelWithSub__J35rD","imp":"setGoal_imp__crb+-"};